export default __webpack_public_path__ + "static/media/add.8ea2e466.svg";